import axios from 'axios';
import { pathOr } from 'ramda';

import { createChangePasswordUrl } from '../api-urls';

const defaultErrorMsg =
  'Ocorreu falha na operação. Nosso serviço pode estar temporariamente com problemas. Tente novamente mais tarde!';

const requestChangePassword = (newPassword, token, recaptchaResponse) => ({
  url: createChangePasswordUrl(recaptchaResponse),
  method: 'post',
  headers: { 'access-token': token },
  data: {
    newPassword: newPassword
  }
});

const getErrosMessage = errors =>
  errors.reduce((acc, item) => {
    const { fieldName, message } = item;
    acc[fieldName] = message;
    return acc;
  }, {});

export const changePassword = async (newPassword, token, recaptchaResponse) => {
  try {
    const response = await axios(requestChangePassword(newPassword, token, recaptchaResponse));
    return { response };
  } catch (err) {
    const { httpStatusCode, validationErrors } = pathOr({}, ['response', 'data'], err);

    switch (httpStatusCode) {
      case 422:
        return { errors: getErrosMessage(validationErrors) };

      default:
        return { errors: { errorMessage: defaultErrorMsg } };
    }
  }
};
